/**
 * @param {number} amount
 * @param {Object} coupon
 */
export default function getCouponDiscount(amount, coupon) {
  let discount = 0;

  if (coupon) {
    if (coupon.amountOff) {
      discount = coupon.amountOff;
    }

    if (coupon.percentOff) {
      discount = amount - amount * (1 - coupon.percentOff / 100);
    }
  }

  return discount;
}
